export { TabsEdit } from './tabs-edit';
